<div class="card border-radius-0 mt-1 p-0">
    <div class="card-header">
        Reporting to Region Head
    </div>
    <div class="card-body p-1">
        <div>
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col" style="width: 3%;">#</th>
                        <th scope="col" style="width: 5px;">Region Code</th>
                        <th scope="col"> Region Name</th>
                        <th scope="col" class="narrow-column">Reporting Approval</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of RegionLoad; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="width: 5px;">{{ site['RegionCode'] }}</td>
                        <td>{{ site['RegionName'] }}</td>
                        <td class="narrow-column">
                            <select class="form-select narrow-dropdown ng-select" name="reportmanager1"
                                [(ngModel)]="site.RegionOwnerId">
                                <option [value]="0">Select</option>
                                <option *ngFor="let manager of UserLoad" [value]="manager.UserMasterId">
                                    {{ manager.UserName }}
                                </option>
                            </select>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button class="btn btn-primary" name="save" (click)="save()" *ngIf="this.common.PageRight.IsEdit">
                    <i class="bi bi-save" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>